import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import type { BranchId } from '../config/constants';
import type { FunnelInterrupt, InterruptId } from './types';

type FindMatchingInterruptArgs = {
  interrupts: readonly FunnelInterrupt[];
  stepId: string;
  branchId: BranchId;
  submittedAnswer: AnswerValue | undefined;
  dismissedIds: readonly InterruptId[];
};

export function findMatchingInterrupt({
  interrupts,
  stepId,
  branchId,
  submittedAnswer,
  dismissedIds,
}: FindMatchingInterruptArgs): FunnelInterrupt | undefined {
  if (typeof submittedAnswer !== 'string') return undefined;

  return interrupts.find(interrupt => {
    if (dismissedIds.includes(interrupt.id)) return false;
    if (interrupt.afterStepId !== stepId) return false;
    if (!interrupt.when.branches.includes(branchId)) return false;
    return interrupt.when.answers.includes(submittedAnswer);
  });
}
